import React from 'react'
import Markdown from 'react-markdown'
import styled from 'styled-components'
import { color, fontSize } from 'utils'

import CheckBox from '../../components/CheckBox'
import { QuestionEmbeddedTitle } from './Steps/KYCStep'

const SingleCheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.6rem;
  align-items: center;

  span {
    font-weight: 600;
    font-size: ${fontSize('sm')};
    color: ${color('white')};
  }
`

const SingleCheckbox = ({ onChange, question }) => {
  return (
    <SingleCheckboxWrapper onClick={onChange}>
      <CheckBox checked={question.checked} />
      <QuestionEmbeddedTitle>
        <Markdown linkTarget='_blank'>{question.text}</Markdown>
      </QuestionEmbeddedTitle>
    </SingleCheckboxWrapper>
  )
}

export default SingleCheckbox
